import {localizeFieldName, useI18nInstance} from "@/plugins/i18n";
import {inventoryReceivingI18nMessages} from "@/models/inventory/InventoryReceiving";

const {t} = useI18nInstance().global

export class ItemMissingSerials {
    static ENDPOINT = '/inventory/missingserials'

    name = ""
    quantity = 0
    total_serials = 0
    location_id = '';
    location_en_name = '';
    location_ar_name = '';

    new_added_count = 0;
    serials: Array<string> = [];

    static from(json: Record<string, unknown> | ItemMissingSerials) {
        const itemMissingSerials = Object.assign(new ItemMissingSerials(), json);
        itemMissingSerials.serials = [];
        return itemMissingSerials;
    }

    includesSerialNumber(serialNumber: string): boolean {
        return !!this.serials?.some(
            (serial) => serial === serialNumber
        )
    }

    insertSerialNumber(serialNumber: string) {
        if (!this.includesSerialNumber(serialNumber))
            this.serials = [serialNumber, ...this.serials]
    }

    removeSerialNumber(index: number) {
        this.serials?.splice(index, 1)
    }

    validateSerials() {
        if (this.serials?.length != this.new_added_count && this.new_added_count <= this.quantity) {
            return t('validation.matchingLength', {
                thisField: localizeFieldName('serialNumbers', inventoryReceivingI18nMessages),
                thatField: localizeFieldName('quantity', inventoryReceivingI18nMessages)
            })
        }
    }
}
